import i18n from 'services/base/i18n';

export default {
  // The percentage of download bandwidth allocated to this device
  downloadSpeed: () => i18n.pgettext('Pages|Bandwidth Prioritization|Item', 'DOWNLOAD SPEED'),
  // The percentage of upload bandwidth allocated to this device
  uploadSpeed: () => i18n.pgettext('Pages|Bandwidth Prioritization|Item', 'UPLOAD SPEED'),
  deviceName: (deviceName: string) => deviceName,
  downloadSpeedValue: (downloadSpeedValue: number) => downloadSpeedValue,
  uploadSpeedValue: (uploadSpeedValue: number) => uploadSpeedValue,
  percent: () => '%',
};
